module.exports = __webpack_public_path__ + "media/images/quote-41721fdef9e96812f2c1581a225397b9.svg";